// @flow
import * as React from 'react';
// $FlowFixMe
import cleanCaption from './cleanCaption';
import styles from './MediaViewerModal.scss';
import { ModalPortal } from 'components/Modal';

const CloseIcon = () => {
  return (
    <svg
      viewBox="9.5 9.5 21 21"
      className={styles.mediaViewerModalCloseButtonIcon}
      aria-hidden="true"
    >
      <g stroke="#fff" className="CloseIcon__group">
        <path d="M15 15l10 10M25 15L15 25" />
        <circle cx="20" cy="20" r="10" fill="none" />
      </g>
    </svg>
  );
};

type MediaViewerModalProps = {
  selectedUgc: ?{ ugctype: UgcType, url: string, caption: string },
  onClose: Function,
};

export default function MediaViewerModal(props: MediaViewerModalProps) {
  const renderMedia = (ugc: Object = {}) => {
    const { ugctype, urlSet, caption } = ugc;

    if (ugctype === 'Image') {
      return <img src={urlSet.full} alt={caption && cleanCaption(caption)} />;
    }

    const { accessType } = ugc;

    if (accessType === 'upload') {
      return (
        <video autoPlay controls>
          <source src={urlSet.raw} type="video/mp4" />
        </video>
      );
    } else if (accessType === 'youtube') {
      return (
        <div className={styles.mediaViewerModalContentWrapVideoEmbedWrap}>
          <iframe src={urlSet.raw} title="Youtube embed" />
        </div>
      );
    }

    return null;
  };

  const { selectedUgc, onClose } = props;

  if (!selectedUgc) {
    return null;
  }
  const caption = selectedUgc.caption;

  return (
    <ModalPortal>
      <div
        className={styles.mediaViewerModal}
        onKeyDown={({ key }: KeyboardEvent) => {
          if (key === 'Escape') {
            onClose();
          }
        }}
      >
        <div
          className={styles.mediaViewerModalContent}
          role="dialog"
          aria-modal="true"
        >
          <div className={styles.mediaViewerModalContentWrap}>
            <button
              type="button"
              className={styles.mediaViewerModalContentWrapCloseButton}
              onClick={onClose}
              aria-label="Close Modal"
            >
              <CloseIcon />
            </button>
            {renderMedia(selectedUgc)}
            {caption && (
              <div className={styles.mediaViewerModalContentWrapCaption}>
                {cleanCaption(caption)}
              </div>
            )}
          </div>
        </div>
      </div>
    </ModalPortal>
  );
}



// WEBPACK FOOTER //
// ./src/components/ContentSection/MediaViewer/MediaViewerModal.js